"use client";

/**
 * FooterDining.tsx
 *
 * Third column of the footer.
 * Shows information about private dining or events.
 */

import React from "react";
import Link from "next/link";

interface FooterDiningProps {
  title: string;
  description: string;
  buttonLabel: string;
  buttonHref: string;
}

const FooterDining = ({
  title,
  description,
  buttonLabel,
  buttonHref,
}: FooterDiningProps) => {
  return (
    <div className="flex flex-col space-y-10">
      <h4 className="font-cormorant text-2xl font-bold uppercase tracking-widest text-white after:content-[''] after:block after:w-10 after:h-0.5 after:bg-[#c59d5f] after:mt-4">
        {title}
      </h4>
      <div className="flex flex-col space-y-4 text-sm font-light leading-relaxed">
        <p className="text-gray-400 transition-colors">{description}</p>
        <Link
          href={buttonHref}
          className="font-bold text-[#c59d5f] tracking-widest uppercase hover:underline cursor-pointer"
        >
          {buttonLabel}
        </Link>
      </div>
    </div>
  );
};

export default FooterDining;
